export default __webpack_public_path__ + "static/media/tipsets.9a216e4a.svg";